module.exports = __webpack_public_path__ + "img/q4.142aae8b.png";